<script setup lang="ts">
import {requireInject} from '@/common/utils/InjectUtil'
import {PRODUCT_SELECTION_INJECTION} from '@/common/services/Products/productSelectionInjection'
import {computed} from 'vue'
import {VsgFlexWrapper, VsgIconChevronRight, VsgIconHeartbeat, VsgListItem} from '@jack-henry/jha-vue-components'
import {BltSearch} from '@/common/services/Search/SearchFactory'
import {$inj} from '@/common/decorators/depinject'
import type {IAccountTypeGroup} from "@/common/services/Products/accountGroupService";
import TFA_GROUPS from "@/common/components/productSelection/TfaGroupsEnum";
import ProductTypeIcon from "@/common/components/product-type-icon/productTypeIcon.vue";

const injection = requireInject(PRODUCT_SELECTION_INJECTION)
const bltSearch = $inj(BltSearch)

const groupMap = computed(() => injection.values.productList.value.map(product => product.group))
const groupHasProduct = (group: IAccountTypeGroup) =>
  groupMap.value.includes(group.typeCode)

const tfaSubgroups = computed(() =>
  injection.values.productGroups.value
    .filter(group => Object.keys(TFA_GROUPS).includes(group.typeCode))
    .filter(group => groupHasProduct(group))
)

const selectSubgroup = (subgroup: IAccountTypeGroup) => {
  injection.methods.setSelectedSubgroup(subgroup)
  injection.methods.goToPane('PRODUCT_SUBGROUP')
}
</script>
<template>
  <div v-if="tfaSubgroups.length"
       class="jh-font-heading-medium-1">
    Tax favored account
  </div>
  <vsg-list-item
      v-for="subgroup in tfaSubgroups"
      @click="selectSubgroup(subgroup)"
      :key="subgroup.typeCode">
    <vsg-flex-wrapper>
      <product-type-icon fill-color="var(--jha-color-primary)"
                         :group-type-code="subgroup.typeCode"/>
      <div class="jh-font-body-regular-1 jha-text-dark">{{ subgroup.typeDescription }}</div>
    </vsg-flex-wrapper>
    <vsg-icon-chevron-right slot="right" />
  </vsg-list-item>
</template>

<style scoped>
@import '../../../branchmanager/assets/typography.css';
@import '../../../branchmanager/assets/typography-colors.css';

jha-list-item {
  cursor: pointer;
  --jha-list-item-horizontal-spacing: 0;
  --jha-list-item-vertical-spacing: var(--jh-space-300);
}

.last-product {
  margin-bottom: var(--jh-space-400);
  border-bottom: 0;
}

.product-icon {
  fill: var(--jha-color-primary);
  margin-right: var(--jh-space-200);
}

jha-icon-chevron-right {
  fill: var(--account-card-secondary-background-color);
}

jha-list-item {
  --jha-list-item-horizontal-spacing: 0;
  margin-left: 0;
}
</style>
